import api from "../../api/api";

export const createUser = async (payload) => {
  const response = await api.post("/users", payload);
  return response.data;
};

export const getAllUsers = async () => {
  const res = await api.get("/users");
  return res.data.data; // atau sesuaikan dengan struktur respons
};

export const updateUser = (id, payload) => {
  return api.put(`/users/${id}`, payload); // ← ✅ perbaiki path di sini
};
export const getUserById = async (id) => {
  const response = await api.get(`/users/${id}`);
  return response.data;
};
export const deleteUser = async (id) => {
  const response = await api.delete(`/users/${id}`);
  return response.data;
};
